import { Periods } from '../types'
import { multiSelectInput } from '../../../inputs/controls'
import { ILogSource } from '../../../../types/logs'

export const getMinRange = (date: Date): Date => new Date(date)

export const getMaxRange = (date: Date): Date | undefined => {
    const newDate = new Date(date)
    newDate.setDate(newDate.getDate() + 13)
    return newDate
}

export const getValidEndDate = (dateFrom: Date, dateTo: Date): Date => {
    const newDateFrom = new Date(dateFrom)
    const actualDateTo = new Date(dateTo)
    const today = new Date()

    const twoWeeksFromNow = new Date(
        newDateFrom.setDate(newDateFrom.getDate() + 13)
    )

    const potentialDate =
        twoWeeksFromNow.getTime() < today.getTime() ? twoWeeksFromNow : today

    const newDateTo =
        actualDateTo.getTime() < potentialDate.getTime() &&
        actualDateTo.getTime() >= dateFrom.getTime()
            ? actualDateTo
            : potentialDate

    return newDateTo
}

export const periodOptions = [
    { label: 'Custom', value: Periods.CUSTOM },
    { label: 'Today', value: Periods.TODAY },
    { label: 'Last 3 days', value: Periods.THREE_DAYS },
    { label: 'Last week', value: Periods.WEEK },
    { label: 'Last 2 weeks', value: Periods.TWO_WEEKS },
]

export enum LogsStatus {
    ONGOING = 'ongoing',
    SUCCESS = 'success',
    FAILURE = 'failure',
}

export const getRange = (state: any, setLogsState: any) => {
    const date = new Date()

    switch (state?.period?.value) {
        case Periods.TODAY:
            setLogsState({
                ...state,
                from: new Date(),
                to: new Date(),
            })
            break

        case Periods.THREE_DAYS:
            setLogsState({
                ...state,
                from: new Date(date?.setDate(date?.getDate() - 2)),
                to: new Date(),
            })
            break

        case Periods.WEEK:
            setLogsState({
                ...state,
                from: new Date(date?.setDate(date?.getDate() - 6)),
                to: new Date(),
            })
            break

        case Periods.TWO_WEEKS:
            setLogsState({
                ...state,
                from: new Date(date?.setDate(date?.getDate() - 13)),
                to: new Date(),
            })
            break

        default:
            setLogsState({ ...state })
            break
    }
}

export interface IPeriod {
    from: string
    to: string
}

export class Period {
    period: IPeriod

    constructor(from: string, to: string) {
        this.period = { from: from, to: to }
    }
}

export const convertDatesToSendFormat = (dates: {
    from: Date
    to: Date
}): Period => {
    const from = dates.from?.toISOString().slice(0, 10)
    const to = dates.to?.toISOString().slice(0, 10)

    return new Period(from, to)
}

export const getPeriodControlDescriptors = () => [
    multiSelectInput({
        name: 'period',
        options: periodOptions,
        label: 'period',
        isMulti: false,
        isColumn: true,
        className: 'mb-1',
    }),
]

type LogSourceOption = { label: string, value: string | null}

const formatLogSourceLabel = (source: ILogSource) => {
    const minLevel = source.min_level
        ? source.min_level.charAt(0).toUpperCase() + source.min_level.slice(1)
        : 'Unknown'
    const lifetime =
        source.log_lifetime_days && source.log_lifetime_days !== 0
            ? `${source.log_lifetime_days} days`
            : 'unlimited'
    const tags =
        !source.tags || source.tags === '*'
            ? 'all tags'
            : `${source.tags}`
    return `${minLevel} (${lifetime}, ${tags})`
}

export function formLogSourceOptions(logSources: ILogSource[]) {
    const logSourceOptions: LogSourceOption[] = [
        { label: 'Default', value: null },
    ]
    logSources.forEach((source: ILogSource) => {
        logSourceOptions.push({
            label: formatLogSourceLabel(source),
            value: source.path
        })
    })
    return logSourceOptions
}

export const getLogSourcesControlDescriptors = (options: LogSourceOption[]) => [
    multiSelectInput({
        name: 'logSource',
        options: options,
        label: 'log source',
        isMulti: false,
        isColumn: true,
        className: 'mb-1',
    }),
]

export function formatLogSourceDetails(source: ILogSource | null | undefined) {
    if (!source) return null
    return {
        'Min level': source.min_level
            ? source.min_level.charAt(0).toUpperCase() + source.min_level.slice(1)
            : 'Unknown',
        'Tags':
            !source.tags || source.tags === '*'
                ? 'All'
                : source.tags,
        'Logs lifetime':
            !source.log_lifetime_days || source.log_lifetime_days === 0
                ? 'Unlimited'
                : `${source.log_lifetime_days} days`,
        'Path': source.path || '',
    }
}

